const LOGO_URL =
  "https://stnpproductoptimyl.blob.core.windows.net/assets/vertical-optimyl-logo-black-text.svg";

export function BrandHeader() {
  return (
    <div className="flex flex-col items-center mb-6">
      <img
        src={LOGO_URL}
        alt="Optimyl Benefits"
        className="mb-2 h-[140px]"
      />
      <span className="text-xs font-semibold tracking-widest text-gray-400 uppercase mt-3">
        Employer Intake
      </span>
    </div>
  );
}
